export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/french.360c611.svg";